import { Link } from "react-router-dom";
import type { PanelMenuItem } from "@/data/panels";

export default function PanelLinks({ links }: { links: PanelMenuItem[] }) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-5">
      <h2 className="font-heading font-semibold text-sm text-foreground-950">İlgili sayfalar</h2>
      <div className="mt-3 flex flex-wrap gap-2">
        {links.map((l) => (
          <Link
            key={l.href}
            to={l.href}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-background-200 text-xs font-medium text-foreground-700 hover:border-accent-300 hover:text-accent-800 transition-colors whitespace-nowrap"
          >
            <i className={`${l.icon} text-sm`} aria-hidden="true"></i>
            {l.label}
          </Link>
        ))}
      </div>
    </div>
  );
}